import { render } from "./ProjectsSection.vue?vue&type=template&id=0da895ba&scoped=true"
const script = {}

import "./ProjectsSection.vue?vue&type=style&index=0&id=0da895ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0da895ba"]])

export default __exports__